import { componentsMap } from "~~/components/HeroRender/components";

/**导入page下面的所有vue组件
 * 根据key值来按需加载
 */
export const createBuiltInComponents = () => {
    const modules = import.meta.glob(`./*.vue`);
    const components = new Map<string, any>();
    for (const path in modules) {
        const result = path.match(/.*\/(.+).vue$/);
        if (result) {
            const name = path.match(/\/(\w+).vue/)![1];
            const currentComponent = modules[path];
            components.set(name, currentComponent);
        }
    }

    [...componentsMap.entries()].forEach(([key, item]) => {
        components.set(key, item);
    });

    return components;
};
